import { render, staticRenderFns } from "./orders-reorder.vue?vue&type=template&id=6ec01aea&"
import script from "./orders-reorder.vue?vue&type=script&lang=js&"
export * from "./orders-reorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports